<template>
  <v-container fluid>
    <v-row wrap align-center>
      <v-col cols=12>
        <div class="text-center">
          <h1 class="headline font-weight-medium">
            {{ $vuetify.lang.t(`$vuetify.landing.papers.title`) }}
          </h1>
        </div>
        <v-divider class="my-3"></v-divider>
      </v-col>
    </v-row>

    <v-row wrap>
      <v-col cols="12" md="6">
        <v-skeleton-loader :loading="!loaded" type="card">
          <papers-list title="$vuetify.landing.papers.journals" :papers="journalPapers"></papers-list>
        </v-skeleton-loader>
      </v-col>
      <v-col cols="12" md="6">
        <v-skeleton-loader :loading="!loaded" type="card">
          <papers-list title="$vuetify.landing.papers.conferences" :papers="conferencePapers"></papers-list>
        </v-skeleton-loader>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import PapersList from './papers/papersList'
import metaMixin from '../../mixins/metaMixin'

export default {
  inject: ['theme'],
  name: 'papersSlide',
  mixins: [metaMixin],
  components: { PapersList },
  props: {
    papers: {
      type: Array,
      default: () => []
    },
    loaded: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    conferencePapers () {
      return this._mapPapers(this.papers.filter(paper => paper.type === 'conference'))
    },
    journalPapers () {
      return this._mapPapers(this.papers.filter(paper => paper.type === 'journal'))
    }
  },
  methods: {
    _mapPapers (papers) {
      const result = {} // 'year -> [...]'
      for (const paper of papers) {
        if (!(paper.year in result)) {
          result[paper.year] = []
        }

        result[paper.year].push(paper)
      }

      return result
    }
  },

  metaInfo: {
    title: 'Drive Safely | Publications',
    meta: [
      { name: 'description', content: 'Publications of the Drive Safely project' },
      { property: 'og:title', content: 'Drive Safely publications' },
      { property: 'og:site_name', content: 'Drive Safely' },
      { property: 'og:description', content: 'Publications of the Drive Safely project' },
      { property: 'og:url', content: 'https://mobiledrivesafely.com/papers' }
    ]
  }
}
</script>

<style scoped>

</style>
